module.exports = __webpack_public_path__ + "static/img/double-seven-bc.93cc61ca.png";